export const paths = {
	root: '/bulkDownload'
};
